import axios from "axios";

export const resolveBaseUrl = (env = process.env) =>
  env.REACT_APP_API_URL || "http://localhost:4001";

const api = axios.create({ baseURL: resolveBaseUrl() });

// Attach the JWT (if present) to every request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// On 401, the token is missing/expired — clear it so the UI reflects logged-out state.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");
    }
    return Promise.reject(error);
  }
);

export const getUserDetails = (username) => api.post("/users/getdetails", { username });
export const login = (username, password) => api.post("/users/login", { username, password });
export const createUser = (payload) => api.post("/users/create", payload);
export const serviceSearch = (payload) => api.post("/users/list", payload);
export const showService = (payload) => api.post("/users/showservice", payload);
export const getComments = (sp_id) => api.post("/users/getcomments", { sp_id });
export const getAvgRating = (user_id) => api.post("/users/getavgrating", { user_id });
export const createReview = (payload) => api.post("/users/review", payload);
export const getReviewId = (name) => api.post("/users/getreviewid", { name });
export const getReviews = (rid) => api.post("/users/getreviews", { rid });
export const updateEmail = (user_id, email) => api.post("/users/updateemail", { user_id, email });
export const updatePhone = (user_id, u_phoneno) => api.post("/users/updatenumber", { user_id, u_phoneno });
export const registerService = (payload) => api.post("/users/registerservice", payload);
export const myListings = (user_id) => api.post("/users/mylistings", { user_id });
export const adminLogin = (username, password) => api.post("/users/adminlogin", { username, password });
export const commentCreate = (payload) => api.post("/users/admincomment", payload);
export const adminViewComments = () => api.post("/users/adminviewcomments", {});
export const usersAll = () => api.post("/users/all", {});

export default api;
